import styled from 'styled-components';

export const SocialLinks = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
  align-items: center;
  @media (max-width: 575.98px) {
    margin: 20px auto;
  }
  &.footer_link {
    @media (max-width: 575.98px) {
      margin: 16px 0px;
    }
  }

  .social-title {
    white-space: nowrap;
    color: #fff;

    &[dir='ltr'] {
      font-size: 10px;
      letter-spacing: 2.18px;
      margin: 5px 13px 0 0;
    }

    &[dir='rtl'] {
      font-size: 14px;
      margin: 5px 0 0 13px;
    }

    @media (max-width: 576px) {
      font-size: 12px;
    }

    &.black_clr {
      color: #000;
    }
  }

  a {
    width: fit-content;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .facebook {
    padding: 3.2px 3px 3.2px 3px;
    background: #3b5998;
  }

  .linkedin {
    padding: 3px;
    background: #0076b4;
  }

  .twitter {
    padding: 3px;
    background: #0e78e0;
  }

  .youtube {
    padding: 3px;
    background: #d12d32;
  }

  .event_facebook {
    margin: 0px 0px;
  }

  .social_icons {
    border-radius: 1px;
    @media (max-width: 991.98px) {
      margin: 0px 8px;
    }
    @media (max-width: 767.98px) {
      margin: 0px 0px;
    }
  }

  .instagram {
    background: linear-gradient(
      45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%
    );
  }

  &.event_sociallink {
    .social_link {
      @media (max-width: 767.98px) {
        margin: 0px 8px;
      }
    }
  }
`;

export const SocialText = styled.span`
  margin: 0 1rem;
`;

export const SocialLinkIcon = styled.img`
  height: 23px;
  object-fit: contain;
`;

export const ShareLinks = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
  align-items: center;
  padding-top: 30px;

  a {
    width: 35px;
    height: 50px;
    margin: 0 4px;
    line-height: 1;
    display: block;
    position: relative;
    cursor: pointer;

    &:nth-child(2) {
      &:before {
        content: none;
      }
    }
  }
`;

export const ShareButton = styled.a`
  padding: 2rem 0 0;
  float: right;

  &:hover {
    .shareheadicon {
      opacity: 1;
      visibility: visible;
      transform: scale(1);
    }
  }
  &:hover {
    .fb_trans,
    .tw_trans,
    .li_trans {
      transform: scale(1);
    }
  }
`;

export const HeadingButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 7px;
  height: 35px;
  width: 34px;
  border-radius: 50%;
  padding: 6px 1px;
  transform: scale(0);
  transition: 0.3s;
  position: relative;
  z-index: 5;

  &.facebookcolor {
    background: #3b5998;
  }

  &.linkedincolor {
    background: #0072b1;
  }

  &.twittercolor {
    background: #00acee;
  }

  &.fb_trans {
    transition-delay: 0.1s;
  }

  &.li_trans {
    transition-delay: 0.2s;
  }

  &.tw_trans {
    transition-delay: 0.2s;
  }
`;

export const ShareHead = styled.div`
  visibility: hidden;
  opacity: 0;
  transition: 0.3s;
  padding-top: 10px;
  z-index: 9999;
  position: relative;
`;

export const SocialLinkFooter = styled.a`
  @media (min-width: 992px) {
    width: ${({ dir }) => (dir === 'rtl' ? '' : '32px!important')};
    margin: 0 8px !important;
  }

  @media (max-width: 575.98px) {
    margin: 0 5px !important;
  }

  &:before {
    display: none;
  }
  .instagram {
    /* background-image: url(/svg/sprites.svg#instagramicon); */
    height: 23px;
    padding: 1px;
    width: 25px !important;
  }
  &.twitter_x {
    background: #000;
    height: 24px;
    svg {
      fill: #fff;
    }
  }
  &.twitter_footer_x {
    background: #000;
    height: 24px;
    width: 25px;
    min-width: 25px !important;
    border-radius: 1px;
    svg {
      fill: #fff;
      width: 25px;
    }
  }
  &.event_social_link {
    .facebook,
    .instagram,
    .linkedin,
    .tiktok,
    .twitter,
    .youtube {
      height: 23px !important;
      width: 25px !important;
      padding: 0px;
    }
    .facebook {
      background-image: url(/svg/sprites.svg#facebookicon);
    }
    .instagram {
      background-image: url(/svg/sprites.svg#instagramicon);
    }
    .linkedin {
      background-image: url(/svg/sprites.svg#linkedinicon);
    }
    .twitter {
      background-image: url(/svg/sprites.svg#twittericon);
    }
    .youtube {
      background-image: url(/svg/sprites.svg#youtubeicon);
    }
    @media (min-width: 992px) {
      width: ${({ dir }) => (dir === 'rtl' ? '' : '27px!important')};
    }
  }
`;
